<div style="background-color: #f4f6fa">
  <ng-template
    #coolertemplate
    let-sku_position="sku_position"
    let-shelfpadding="shelfpadding"
    [ngTemplateOutlet]="coolertemplate"
  >
    <div
      style="
        width: 52%;
        position: relative;
        left: 21.58vw;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      "
    >
      <!-- <div style="font-size: 1.2vw; font-weight: 600; margin-bottom: 2vh">
        {{ planogram_details.unit }}, {{ planogram_details.channel }} ,
        {{ planogram_details.cooler }}
      </div> -->
      <div class="download-info">
        <button
          class="download-button"
          (click)="downloadCoolerInfo('assortment')"
          mat-flat-button
        >
          <img
            style="margin-right: 8px"
            src="../../assets/assortment_sku.svg"
          />
          Download Assortment
        </button>
        <button
          style="margin-left: 15px"
          class="download-button"
          (click)="downloadCoolerInfo('image')"
          mat-flat-button
        >
          <img
            style="margin-right: 8px"
            src="../../assets/download_image.svg"
          />
          Download Image
        </button>
      </div>
      <div id="image-capture-container">
        <div>
          <div style="display: flex; align-items: flex-end; gap: 10px">
            <div *ngFor="let cooler of No_Of_Cooler">
              <table id="cooler" aria-describedby="">
                <thead>
                  <tr>
                    <th
                      class="no-sku-placement-cell"
                      [ngStyle]="{
                        'height.vh': 2,
                        width: '100%',
                        'text-align': 'center',
                        'border-bottom': '1px solid black'
                      }"
                    ></th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    *ngFor="
                      let s of [].constructor(NoOfShelves[cooler]);
                      let shelf = index
                    "
                  >
                    <td *ngIf="!reset" class="sku-container">
                      <div
                        class="sku-set-container"
                        *ngFor="
                          let sku of findShelfInSkuList(shelf + 1, cooler);
                          let position = index
                        "
                      >
                        <div
                          style="
                            display: flex;
                            flex-direction: column;
                            justify-content: flex-end;
                            align-items: center;
                          "
                          *ngFor="
                            let v of [].constructor(sku.final_facings);
                            let i = index
                          "
                        >
                          <img
                            style="height: 50px; margin-right: 4px"
                            [ngStyle]="{
                              'width.em':
                                (sku.diameter_mm * CONFIG.MMTOPIXCEL) /
                                CONFIG.WIDTHCONSTANT,
                              'height.em':
                                (sku.height_mm *
                                  sku.facings_multiplier *
                                  CONFIG.MMTOPIXCEL) /
                                CONFIG.HEIGHTCONSTANT
                            }"
                            [src]="sku.blob_img_uri||review_screen_sku_image_list[sku.sku_face+'_'+sku.category]"
                          />
                        </div>
                        <div
                          style="
                            display: flex;
                            flex-direction: column;
                            justify-content: flex-end;
                            align-items: center;
                          "
                          *ngIf="sku.final_facings == 0"
                        >
                          <img
                            style="height: 50px; margin-right: 4px"
                            [ngStyle]="{
                              'width.em':
                                (sku.diameter_mm * CONFIG.MMTOPIXCEL) /
                                CONFIG.WIDTHCONSTANT,
                              'height.em':
                                (sku.height_mm *
                                  sku.facings_multiplier *
                                  CONFIG.MMTOPIXCEL) /
                                CONFIG.HEIGHTCONSTANT
                            }"
                            src="../../assets/cci_img_placeholder.png"
                          />
                        </div>
                      </div>
                    </td>
                    <td *ngIf="reset" class="sku-container">
                      <div
                        class="sku-set-container"
                        *ngFor="
                          let sku of findShelfInSkuList(shelf + 1, cooler);
                          let position = index
                        "
                      >
                        <div
                          cdkDropList
                          [id]="addDropId(shelf + 1, position, cooler)"
                          (cdkDropListDropped)="
                            dropped(
                              $event,
                              shelf + 1,
                              position,
                              sku.shelf,
                              sku.max_limit,
                              cooler,
                              sku,
                              i
                            )
                          "
                          style="
                            display: flex;
                            flex-direction: column;
                            justify-content: flex-end;
                            align-items: center;
                          "
                          *ngFor="
                            let v of sku.final_facings === 0
                              ? [0]
                              : [].constructor(sku.final_facings);
                            let i = index
                          "
                        >
                          <em
                            *ngIf="sku.final_facings !== 0 && !local_reset"
                            class="bi bi-x-lg sku-edit"
                            style="color: #e61a27"
                            (click)="removeSku(sku, position, cooler, i)"
                          ></em>
                          <img
                            *ngIf="sku.final_facings !== 0"
                            style="height: 50px; margin-right: 4px"
                            [ngStyle]="{
                              'width.em':
                                (sku.diameter_mm * CONFIG.MMTOPIXCEL) /
                                CONFIG.WIDTHCONSTANT,
                              'height.em':
                                (sku.height_mm *
                                  sku.facings_multiplier *
                                  CONFIG.MMTOPIXCEL) /
                                CONFIG.HEIGHTCONSTANT
                            }"
                            [src]="sku.blob_img_uri||review_screen_sku_image_list[sku.sku_face+'_'+sku.category]"
                          />
                          <img
                            *ngIf="sku.final_facings == 0"
                            style="height: 50px; margin-right: 4px"
                            [ngStyle]="{
                              'width.em':
                                (sku.diameter_mm * CONFIG.MMTOPIXCEL) /
                                CONFIG.WIDTHCONSTANT,
                              'height.em':
                                (sku.height_mm *
                                  sku.facings_multiplier *
                                  CONFIG.MMTOPIXCEL) /
                                CONFIG.HEIGHTCONSTANT
                            }"
                            src="../../assets/cci_img_placeholder.png"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td
                      class="no-sku-placement-cell"
                      [ngStyle]="{
                        'height.px': 100,
                        width: '100%',
                        'text-align': 'center'
                      }"
                    >
                      <img
                        src="../../assets/coke_white_logo.png"
                        [ngStyle]="getFooterImageStyle(cooler)"
                        alt="'"
                      />
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
        <app-loader [is_show_loader]="(planogram_loader | async)!"></app-loader>
      </div>
    </div>
  </ng-template>
</div>
